import { Outlet, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { Header } from "../components/Header/Header";
import { Footer } from "../components/Footer/Footer";

import "./MainLayout.style.css";

export const MainLayout = () => {

    const { t } = useTranslation();
    const navigate = useNavigate();

    return (
        <>
            <Header />

            {/* Bouton retour */}
            <button
                className="back-btn"
                onClick={() => navigate(-1)}
                aria-label={t('previous')}
            >
                ←
            </button>

            <main>
                <Outlet />
            </main>

            <Footer />
        </>
    );
};